(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mas-google-reviews-dialog"] && !Shopify.designMode) return;
  try {
    if (!window.masGoogleReviewPopupBootstrap) {
  window.masGoogleReviewPopupBootstrap = true;
  document.addEventListener('shopify:section:unload', (event) => event.target.querySelectorAll('mas-google-review-modal dialog[open]').forEach((dialog) => dialog.close()));
  document.addEventListener('click', async (event) => {
    const trigger = event.target.closest('[data-mas-google-reviews-open], [data-mas-review-retry]');
    if (!trigger || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const dialog = trigger.closest('mas-google-review-modal')?.querySelector('dialog') || document.getElementById(trigger.getAttribute('aria-controls')) || document.querySelector('mas-google-review-modal dialog');
    const host = dialog?.closest('mas-google-review-modal');
    if (!host || typeof dialog.showModal !== 'function') return;
    if (!host.masPopupShell) {
      host.masPopupShell = {};
      dialog.addEventListener('close', () => {
        const saved = host.masPopupShell.scroll;
        if (saved) { document.documentElement.style.overflow = saved.root; document.body.style.overflow = saved.body; window.scrollTo({ left: saved.x, top: saved.y, behavior: 'instant' }); host.masPopupShell.scroll = null; }
        host.masPopupShell.trigger?.isConnected && host.masPopupShell.trigger.focus({ preventScroll: true });
      });
      dialog.querySelector('[data-mas-review-dialog-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (click) => { if (click.target !== dialog) return; const box = dialog.getBoundingClientRect(); if (click.clientX < box.left || click.clientX > box.right || click.clientY < box.top || click.clientY > box.bottom) dialog.close(); });
      dialog.addEventListener('keydown', (key) => {
        if (key.key !== 'Tab' || key.defaultPrevented) return;
        const items = Array.from(dialog.querySelectorAll('a[href],button,[tabindex]')).filter((item) => item.tabIndex >= 0 && !item.matches(':disabled') && !item.closest('[hidden],[inert]') && item.getClientRects().length && getComputedStyle(item).visibility !== 'hidden');
        const first = items[0], last = items[items.length - 1], active = document.activeElement;
        if (!first) { key.preventDefault(); dialog.focus(); }
        else if (!dialog.contains(active) || active === dialog || (key.shiftKey && active === first) || (!key.shiftKey && active === last)) { key.preventDefault(); (key.shiftKey ? last : first).focus(); }
      });
    }
    if (!dialog.open) {
      host.masPopupShell.trigger = trigger;
      const saved = { root: document.documentElement.style.overflow, body: document.body.style.overflow, x: window.scrollX, y: window.scrollY };
      try { dialog.showModal(); } catch (_) { return; }
      host.masPopupShell.scroll = saved;
      document.documentElement.style.overflow = 'hidden'; document.body.style.overflow = 'hidden';
    }
    event.preventDefault();
    const retry = host.querySelector('[data-mas-review-retry]');
    const userRetry = trigger.matches('[data-mas-review-retry]');
    if (document.activeElement === retry && dialog.open) host.querySelector('.mas-google-review-dialog__body').focus({ preventScroll: true });
    retry.hidden = true;
    try {
      host.masPopupImport ||= import(host.dataset.moduleUrl).catch((error) => { host.masPopupImport = null; throw error; });
      const popup = await host.masPopupImport;
      if (host.isConnected) popup.loadReviews(host, userRetry);
    } catch (_) { if (host.isConnected) { host.querySelector('[data-review-status]').textContent = host.dataset.error; retry.hidden = false; if (userRetry && dialog.open) retry.focus({ preventScroll: true }); } }
  });
}
  } catch(e) { console.error(e); }
})();

})();
